/*
 * @Author: Vanny
 * @Date: 2019-01-09 13:12:33
 * @LastEditors: Vanny
 * @LastEditTime: 2019-08-19 11:12:08
 * @Description: 数据统计-仓库
 */
import { call, put } from 'redux-saga/effects';
import * as dashboardApi from '../../services/dashboardApi';

const initialState = {
  yList: [],
  wList: [],
  aList: [],
  today: {},
  exist: false,
};

export const state = initialState;

export const effects = {
  *getInfo(action) {
    const response = yield call(dashboardApi.getSummary);
    if (response) {
      const { trade_trend, transaction_top10, transaction_week_compare, ...props } = response;
      yield put({
        type: 'dashboard/setState',
        payload: {
          yList: trade_trend,
          wList: transaction_week_compare,
          aList: transaction_top10,
          today: { ...props },
          exist: true,
        },
      });
    }
  },
};
